import { render } from "./Cacheclear.vue?vue&type=template&id=50807fe6"
import script from "./Cacheclear.vue?vue&type=script&lang=js"
export * from "./Cacheclear.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/cacheclear/Cacheclear.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50807fe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50807fe6', __exports__)) {
    api.reload('50807fe6', __exports__)
  }
  
  module.hot.accept("./Cacheclear.vue?vue&type=template&id=50807fe6", () => {
    api.rerender('50807fe6', render)
  })

}


export default __exports__